import BaseList from './BaseList';
import Staff from '../Staff';

export default class StaffList extends BaseList {
  constructor(values = []) {
    super(values, Staff);
  }
}
